import { render } from "./Reflect.vue?vue&type=template&id=18155524"
import script from "./Reflect.vue?vue&type=script&lang=js"
export * from "./Reflect.vue?vue&type=script&lang=js"

import "./Reflect.vue?vue&type=style&index=0&id=18155524&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__